import AdminLayout from '@/layouts/AdminLayout.vue'

export default [
  {
    path: '/distributor-networks/create',
    name: 'distributorNetworkCreate',
    component: () =>
      import(
        '@/views/restricted/distributor-networks/distributor-network/DistributorNetworkCreateView.vue'
      ),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_DISTRIBUTOR_NETWORK_CREATE_PERMISSION'],
      menuSelected: 'networks'
    }
  },
  {
    path: '/distributor-networks/:networkId/edit',
    name: 'distributorNetworkUpdate',
    component: () =>
      import(
        '@/views/restricted/distributor-networks/distributor-network/DistributorNetworkUpdateView.vue'
      ),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_DISTRIBUTOR_NETWORK_UPDATE_PERMISSION'],
      menuSelected: 'networks'
    }
  },
  {
    path: '/distributor-networks/:networkId',
    name: 'distributorNetworkDetail',
    component: () =>
      import(
        '@/views/restricted/distributor-networks/distributor-network/DistributorNetworkDetailLayoutView.vue'
      ),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_DISTRIBUTOR_NETWORK_READ_PERMISSION'],
      menuSelected: 'networks'
    }
  },
  {
    path: '/distributor-networks',
    name: 'distributorNetworks',
    component: () =>
      import('@/views/restricted/distributor-networks/DistributorNetworkLayoutView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_DISTRIBUTOR_NETWORK_READ_PERMISSION', 'ADMIN_STORE_READ_PERMISSION'],
      menuSelected: 'networks'
    }
  }
]
